import {
  createElementVNode as _createElementVNode,
  openBlock as _openBlock,
  createElementBlock as _createElementBlock,
} from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
      },
      [
        _createElementVNode("path", {
          d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM15.0156 6.33679C14.4612 5.82104 13.5936 5.8524 13.0779 6.40682L9.04105 10.7464L6.82667 8.78753C6.25951 8.28582 5.39302 8.33887 4.89131 8.90602C4.38959 9.47318 4.44265 10.3397 5.0098 10.8414L8.22573 13.6862C8.78288 14.1791 9.6314 14.1378 10.138 13.5932L15.0856 8.2745C15.6014 7.72008 15.57 6.85253 15.0156 6.33679Z",
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
        }),
      ],
    )
  );
}
